module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom","umd":"react-dom"}
// module id = 22
// module chunks = 0